import { defineComponent as h, mergeModels as m, useModel as c, computed as l, ref as g, provide as v, createElementBlock as d, openBlock as o, renderSlot as T, normalizeProps as y, guardReactiveProps as _, unref as E, Fragment as x, renderList as w, createBlock as I } from "vue";
import B, { moveSortableElements as k } from "./useSortable.js";
import S from "./ThumbnailEmpty.js";
import { T as C } from "./ThumbnailGroup.keys-EJ4qFNhx.js";
import { _ as D } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const M = /* @__PURE__ */ h({
  __name: "ThumbnailGroup",
  props: /* @__PURE__ */ m({
    draggable: { type: Boolean, default: !1 },
    radius: { default: "rounded" },
    removable: { type: Boolean, default: !1 },
    showEmpty: { type: Boolean, default: !1 },
    emptyOptions: { default: () => ({ max: 6 }) },
    thumbnails: { default: () => [] }
  }, {
    activeThumbnail: {
      default: -1
    },
    activeThumbnailModifiers: {}
  }),
  emits: /* @__PURE__ */ m(["dragStart", "dragEnd", "update:thumbnails"], ["update:activeThumbnail"]),
  setup(s, { emit: p }) {
    const n = p, t = s, r = c(s, "activeThumbnail"), a = l({
      get() {
        return t.thumbnails;
      },
      set(e) {
        n("update:thumbnails", e);
      }
    }), u = g(null), { isDragging: i } = B({
      ref: u,
      list: a,
      isEnabled: t.draggable,
      ghostClass: "thumbnail-ghost",
      chosenClass: "thumbnail-chosen",
      sortInPlace: !1,
      onDragStart: (e) => n("dragStart", e),
      onDragEnd: (e) => {
        r.value = e.newIndex, k({ list: a, from: e.oldIndex, to: e.newIndex }), n("dragEnd", e);
      }
    }), b = l(() => {
      if (!t.showEmpty) return 0;
      const { max: e } = t.emptyOptions || {};
      return a.value.length < e ? e - a.value.length : 0;
    });
    return v(
      C.key,
      Object.freeze({
        draggable: l(() => t.draggable),
        removable: l(() => t.removable),
        thumbnails: a,
        radius: t.radius,
        activeThumbnail: r,
        isDragging: i
      })
    ), (e, O) => (o(), d("ul", {
      ref_key: "thumbnailRef",
      ref: u,
      class: "stash-thumbnail-group tw-flex tw-flex-wrap tw-gap-3",
      "data-test": "stash-thumbnail-group"
    }, [
      T(e.$slots, "default", y(_({ activeThumbnail: r.value, isDragging: E(i) })), void 0, !0),
      (o(!0), d(x, null, w(b.value, (N, f) => (o(), I(S, {
        key: `empty_thumb_${f}`
      }))), 128))
    ], 512));
  }
}), $ = /* @__PURE__ */ D(M, [["__scopeId", "data-v-d7a887de"]]);
export {
  $ as default,
  k as moveSortableElements
};
//# sourceMappingURL=ThumbnailGroup.js.map
